import React, { useContext, /*useEffect,*/ useMemo } from 'react'
import { DashboardOutlined, MailFilled, BellFilled, FileTextOutlined, ProfileOutlined, FileSearchOutlined, FileDoneOutlined, BookOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faCircleUser, faSquarePlus, faUsers, faBell, faBook, faHandshake, faAddressCard, faGraduationCap, faPaste, faDownload, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { Menu, Badge, Space } from 'antd';
import { Link } from "react-router-dom";
import constants from '../../Constants/constants';
import { COOKIE, getCookie } from '../../Services/Cookie';
import { UserContext } from '../../Context';
import { breadcrumbHelper, onChangeMenu, onChangeSubMenu } from '../../GlobalFunctions/GlobalFunctions';

const { SubMenu } = Menu;

const MenuRender = ({ count, hasLearningOutcomes = false, onClose }) => {
	const { selectedMenuItem, selectedSubMenuItem, setSelectedMenuItem, setSelectedSubMenuItem, setBreadcrumbItems } = useContext(UserContext);
	const ID = parseInt(getCookie(COOKIE.UserId))
	const userRoleId = getCookie(COOKIE.Role);
	const isAdvisor = getCookie(COOKIE.IsAdvisor);
	const isStudent = userRoleId === '0'
	const isClinicalDirector = userRoleId === '6'
	const isReportingTo = getCookie(COOKIE.ReportingTo) || false

	const handleClick = (item) => {
		breadcrumbHelper([], setBreadcrumbItems)
		onChangeMenu(item, setSelectedMenuItem, setSelectedSubMenuItem);
		if (onClose) onClose(); // close the drawer
	};

	const menuProps = useMemo(() => ({
		theme: "dark",
		mode: "inline",
		selectedKeys: [selectedMenuItem],
		openKeys: selectedSubMenuItem?.length > 0 ? selectedSubMenuItem.split(',') : [],
		onOpenChange: (keys) => onChangeSubMenu(keys, setSelectedSubMenuItem),
	}), [selectedMenuItem, selectedSubMenuItem]);

	// useEffect(() => {
	// 	sessionStorage.removeItem('activeStudentTab')
	// 	sessionStorage.removeItem('activeStudentTabTitle')
	// 	sessionStorage.removeItem('activeStudentSubTab')
	// 	sessionStorage.removeItem('activeExtraButton')
	// }, [selectedMenuItem, selectedSubMenuItem])

	const StudentAcademicsMenu = () => (
		<Menu {...menuProps} onClick={handleClick}>
			<Menu.Item key="student-dashboard" icon={<DashboardOutlined className='!block' />}>
				<Link to="/student-dashboard">
					{constants.Dashboard}
				</Link>
			</Menu.Item>
			<SubMenu icon={<FontAwesomeIcon icon={faCircleUser} />}
				key="advising"
				title="Advising"
			>
				<Menu.Item key="student-advisor-signup"><Link to="/student-advisor-signup">{constants.AdvisorSignup}</Link></Menu.Item>
				<Menu.Item key="student-checklist"><Link to="/student-checklist">{constants.Checklist}</Link></Menu.Item>
				<Menu.Item key="plan-of-study"><Link to="/plan-of-study">{constants.PlanOfStudyAdvisement}</Link></Menu.Item>
			</SubMenu>
			<Menu.Item key="student-courses" icon={<FontAwesomeIcon icon={faGraduationCap} />}>
				<Link to="/student-courses">{constants.Courses}</Link>
			</Menu.Item>
			<Menu.Item key="semester-courses" icon={<BookOutlined />}>
				<Link to="/semester-courses">{constants.SemesterCourses}</Link>
			</Menu.Item>
			<Menu.Item key="student-notes" icon={<FileTextOutlined />}>
				<Link to="/student-notes">
					Notes
				</Link>
			</Menu.Item>
			<Menu.Item key="all-surveys" icon={<ProfileOutlined />}>
				<Link to="/all-surveys">
					{constants.Surveys}
				</Link>
			</Menu.Item>
			{StudentClinicalMenu()}
			<Menu.Item key="student-notifications" icon={<BellFilled />}>
				<Space>
					<Link to="/student-notifications" state={{ user: "student" }}>
						Notifications
					</Link>
					{count > 0 && <Badge className="badge-style" count={count} size="small" showZero={true} />}
				</Space>
			</Menu.Item>
		</Menu>
	)

	const StudentClinicalMenu = () => (
		<Menu {...menuProps} onClick={handleClick}>
			<Menu.Item
				key="clinical-student-clearances"
				icon={<FileDoneOutlined />}
			><Link to="/clinical-student-clearances">{constants.Clearances}</Link>
			</Menu.Item>
			<Menu.Item
				key="clinical-observation-requirements"
				icon={<FileSearchOutlined />}
			><Link to="/clinical-observation-requirements">{constants.Observations}</Link>
			</Menu.Item>
		</Menu>
	)
	
	const AdminAcademicsMenu = () => (
		<Menu {...menuProps} onClick={handleClick}>
			<Menu.Item key="dashboard" icon={<DashboardOutlined className='!block' />}>
				<Link to="/dashboard">
					{constants.Dashboard}
				</Link>
			</Menu.Item>
			{(userRoleId === '1' || userRoleId === '3') ?
				<Menu.Item
					key="create-semester"
					icon={<FontAwesomeIcon icon={faSquarePlus} />}>
					<Link to="/create-semester">Create Semester</Link>
				</Menu.Item>
				: null}
			{!isClinicalDirector ?
				<SubMenu icon={<FontAwesomeIcon icon={faUsers} />}
					key="students"
					title="Students"
				>
					<Menu.Item key="student-listing">
						<Link to="/student-listing">
							{constants.Listing}
						</Link>
					</Menu.Item>
					{(userRoleId === '1' || userRoleId === '3') ?
						<Menu.Item key="student-registration">
							<Link to="/student-registration">
								{constants.Registration}
							</Link>
						</Menu.Item>
						: null}
				</SubMenu> :
				<Menu.Item key="student-clinics-list" icon={<FontAwesomeIcon icon={faUsers} />}>
					<Link to="/student-clinics-list">
						{constants.StudentClinicsListing}
					</Link>
				</Menu.Item>}
			{((userRoleId !== '2' && userRoleId !== '4' && userRoleId !== '5' && userRoleId !== '6') || isAdvisor === '1') &&
				<SubMenu icon={<FontAwesomeIcon icon={faCircleUser} />}
					key="advising"
					title="Advising"
				>
					{(userRoleId === '1' || userRoleId === '3') ?
						<Menu.Item key="assigning-advisors">
							<Link to="/assigning-advisors">
								Assigning Advisors
							</Link>
						</Menu.Item>
						: null}
					{(userRoleId === '1' || userRoleId === '3' || isAdvisor === '1') ?
						<Menu.Item key="advising-documents">
							<Link to="/advising-documents">Advising Documents</Link>
						</Menu.Item> : null}
					{isAdvisor === '1' ?
						<Menu.Item key="advisor-signup">
							<Link to="/advisor-signup">{constants.AdvisorSignup}</Link>
						</Menu.Item> : null}
					{isAdvisor === '1' ?
						<Menu.Item key="list-schedule">
							<Link to="/list-schedule" state={{ faculty_id: ID }}>{constants.AdvisorSchedule}</Link>
						</Menu.Item> : null}
				</SubMenu>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<Menu.Item key="assign-mentors" icon={<FontAwesomeIcon icon={faHandshake} />}>
					<Link to='/assign-mentors'>
						{constants.AssigningMentors}
					</Link>
				</Menu.Item>
			}
			{((userRoleId !== '2' && userRoleId !== '4' && userRoleId !== '5') || isAdvisor === '1' || userRoleId === "6" || isReportingTo) &&
				<SubMenu icon={<MailFilled />}
					key="emails"
					title="Emails"
				>
					{(userRoleId === '1' || userRoleId === '3' || isAdvisor === '1' || userRoleId === "6" || isReportingTo) ?
						<Menu.Item key="send-emails">
							<Link to="/send-emails">Send Emails</Link>
						</Menu.Item> : null}
					{(userRoleId === '1' || userRoleId === '3' || (userRoleId === '2' || isAdvisor === '1') || userRoleId === "6" || isReportingTo) ?
						<Menu.Item key="email-reports">
							<Link to="/email-reports">Email Reports</Link>
						</Menu.Item> : null}
				</SubMenu>
			}
			{
				<SubMenu icon={<FontAwesomeIcon icon={faPaste} />}
					key='surveys'
					title="Surveys"
				>
					{((userRoleId === '1' || userRoleId === '3') || getCookie(COOKIE.HasSurveyPermission) === '1') ?
						<Menu.Item key="manage-surveys">
							<Link to="/manage-surveys">{constants.ManageSurveys}</Link>
						</Menu.Item>
						: null}
					{(userRoleId === '1' || userRoleId === '3') ?
						<Menu.Item key="survey-types">
							<Link to="/survey-types">{constants.SurveysType}</Link>
						</Menu.Item>
						: null}
					{hasLearningOutcomes &&
						<Menu.Item key="learning-outcomes">
							<Link to="/learning-outcomes">{constants.LearningOut}</Link>
						</Menu.Item>
					}
					<Menu.Item key="my-surveys">
						<Link to="/my-surveys">{constants.MySurveys}</Link>
					</Menu.Item>
				</SubMenu>
			}
			{/* based on a flag */}
			{((userRoleId === '2' || userRoleId === '4' || userRoleId === '5') && isAdvisor !== '1') &&
				<Menu.Item key="my-courses" icon={<FontAwesomeIcon icon={faGraduationCap} />}>
					<Link to="/my-courses">My Courses</Link>
				</Menu.Item>
			}
			{((userRoleId !== '2' && userRoleId !== '4' && userRoleId !== '5') || isAdvisor === '1') &&
				<SubMenu icon={<FontAwesomeIcon icon={faGraduationCap} />}
					key="courses"
					title="Courses"
				>
					{(userRoleId === '1' || userRoleId === '3') ?
						<Menu.Item key="active-course-list">
							<Link to="/active-course-list">Active Courses</Link>
						</Menu.Item> : null}
					{(userRoleId === '1' || userRoleId === '3' || isAdvisor === '1') ?
						<Menu.Item key="student-course-list">
							<Link to="/student-course-list">Student Course List</Link>
						</Menu.Item> : null}
					{(userRoleId === '1' || userRoleId === '3') ?
						<Menu.Item key="faculty-courses-assignment">
							<Link to="/faculty-courses-assignment">Faculty Courses</Link>
						</Menu.Item> : null}
					{((userRoleId !== '1' && userRoleId !== '3') || isAdvisor === '1') ?
						<Menu.Item key="my-courses">
							<Link to="/my-courses">My Courses</Link>
						</Menu.Item> : null} {/* based on a flag */}
					{((userRoleId === '1' || userRoleId === '3')) ?
						<Menu.Item key="pending-courses-report">
							<Link to="/pending-courses-report">Pending Courses Report</Link>
						</Menu.Item> : null}
					{(userRoleId === '1' || userRoleId === '3') ?
						<SubMenu
							key="manage-courses"
							title="Manage Courses"
						>
							<Menu.Item key="areas-courses">
								<Link to="/areas-courses">Areas - Courses</Link>
							</Menu.Item>
							<Menu.Item key="slp-courses">
								<Link to="/slp-courses">SLP Courses</Link>
							</Menu.Item>
							<Menu.Item key="free-electives">
								<Link to="/free-electives">Free Electives</Link>
							</Menu.Item>
							<Menu.Item key="assessments">
								<Link to="/assessments">Assessments</Link>
							</Menu.Item>
						</SubMenu>
						: null}
				</SubMenu>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<SubMenu icon={<FontAwesomeIcon icon={faBook} />}
					key='gpa'
					title="GPA"
				>
					<Menu.Item key="academic-specification">
						<Link to="/academic-specification">{constants.AcademicSpecification}</Link>
					</Menu.Item>
					<Menu.Item key="student-gpa">
						<Link to="/student-gpa">{constants.StudentGPA}</Link>
					</Menu.Item>
					<Menu.Item key="dismissed-list">
						<Link to="/dismissed-list">{constants.DissmissedList}</Link>
					</Menu.Item>
					<Menu.Item key="gpa-history">
						<Link to="/gpa-history">{constants.GpaHistory}</Link>
					</Menu.Item>
				</SubMenu>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<SubMenu icon={<FontAwesomeIcon icon={faUsers} />}
					key="staff"
					title="Staff"
				>
					<Menu.Item key="staff-list">
						<Link to="/staff-list">Listing</Link>
					</Menu.Item>
					<Menu.Item key="staff-registration">
						<Link to="/staff-registration">Registration</Link>
					</Menu.Item>
				</SubMenu>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<Menu.Item key="user-roles" icon={<FontAwesomeIcon icon={faAddressCard} />}>
					<Link to='/user-roles'>
						{constants.UserRoles}
					</Link>
				</Menu.Item>
			}
			{
				((userRoleId !== "4") || isReportingTo) &&
				<Menu.Item key="clinical-report-listing" icon={<FontAwesomeIcon icon={faPaste} />}>
					<Link to="/clinical-report-listing">
						{constants.ClinicsReport}
					</Link>
				</Menu.Item>
			}
			{(userRoleId === '1' || userRoleId === '3' || userRoleId === '6') &&
				<Menu.Item key="notification-list" icon={<FontAwesomeIcon icon={faBell} />}>
					<Link to='/notification-list'>
						<Space>
							{constants.Notifications}
							{count > 0 && <Badge className="badge-style" count={count} size="small" showZero={true} />}
						</Space>
					</Link>
				</Menu.Item>
			}
			{(userRoleId !== '1' && userRoleId !== '3' && userRoleId !== "6") &&
				<Menu.Item key="notifications" icon={<FontAwesomeIcon icon={faBell} />}>
					<Link to='/notifications'>
						<Space>
							{constants.Notifications}
							{count > 0 && <Badge className="badge-style" count={count} size="small" showZero={true} />}
						</Space>
					</Link>
				</Menu.Item>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<Menu.Item key="student-import" icon={<FontAwesomeIcon icon={faDownload} />}>
					<Link to="/student-import">
						{constants.StudentImports}
					</Link>
				</Menu.Item>
			}
			{(userRoleId === '1' || userRoleId === '3') &&
				<Menu.Item key="activity-logs" icon={<FontAwesomeIcon icon={faClockRotateLeft} />}>
					<Link to="/activity-logs">
						{constants.ActivityLogs}
					</Link>
				</Menu.Item>
			}
			{(userRoleId === "1" || userRoleId === "3" || userRoleId === "6") && AdminClinicalMenu()}
		</Menu>
	)

	const AdminClinicalMenu = () => {
		return (
			<SubMenu
				key="clinical-settings"
				title={constants.Settings}
				icon={<FontAwesomeIcon icon={faCog} />}
			>
				<Menu.Item key="clinical-clearances-settings">
					<Link to="/clinical-clearances-settings">
						{constants.Clearances}
					</Link>
				</Menu.Item>
				<Menu.Item key="clinical-observations-settings">
					<Link to="/clinical-observations-settings">
						{constants.Observations}
					</Link>
				</Menu.Item>
				<Menu.Item key="clinical-clinics-settings">
					<Link to="/clinical-clinics-settings">
						{constants.Clinics}
					</Link>
				</Menu.Item>
			</SubMenu>
		)
	}

	return isStudent ? StudentAcademicsMenu() : AdminAcademicsMenu()
}

export default MenuRender;